import get from 'lodash/get';

/**
 *
 * get Iframe height for react
 */
export function getiFrameHeight() {
  const iFrame = document.getElementById('TL_iframe') as HTMLIFrameElement;
  const iFrameBody = iFrame?.contentWindow?.document.body;
  return iFrameBody?.offsetHeight;
}

/**
 * Helper function to remove the loading cloak in popups that have React components
 */
export function removeLoadingCloak() {
  if (window.top!.TL && window.top!.TL.Popups && window.top!.TL.Popups.removeLoadingCloak) {
    window.top!.TL.Popups.removeLoadingCloak();
  }
}

export const mapUniqueValuesByKeyId = <T extends { id: string }>(
  values: Record<string, T>,
  key: string | string[],
  initialValue?: Record<string, Set<string>>,
) => {
  return Object.values(values).reduce((accumulator: Record<string, Set<string>>, value: T) => {
    const keyId = get(value, Array.isArray(key) ? [...key, 'id'] : [key, 'id']);
    if (!keyId) {
      return accumulator;
    }

    if (!accumulator[keyId]) {
      accumulator[keyId] = new Set();
    }

    accumulator[keyId].add(value.id);
    return accumulator;
  }, initialValue || {});
};

export const normalizeArrayByKeyWithOriginalObject = <T = TSFixMe>(
  array: T[] | undefined | null,
  key: keyof T,
): Record<string, T> => {
  if (!array) {
    return {};
  }
  return array.reduce((acc, curr) => {
    let foundKey = curr[key] as unknown as string | number;
    if (typeof foundKey === 'number') {
      foundKey = foundKey.toString();
    }

    return { ...acc, [foundKey]: { ...curr } };
  }, {});
};

export const sanitizeLegacyJavascript = (javascript: string) => {
  let sanitizedJavascript;

  // escape unicode escape sequence ('\u')
  sanitizedJavascript = javascript.replace(/[^\\]\\u/g, '\\\\u');

  // remove nasty chars
  sanitizedJavascript = javascript.replace(/\u2028/g, '\\u2028').replace(/\u2029/g, '\\u2029');

  return sanitizedJavascript;
};

export const executeLegacyJavascriptModulesDomReadyCallbacks = () => {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      window.executeDomReadyCallBacks();
      window.initialDomReadyCallBacksFinished = true;
    });
    return;
  }

  window.executeDomReadyCallBacks();
  window.initialDomReadyCallBacksFinished = true;
};

export const legacyJavascriptPathGenerator = () => {
  const buildIdentifier = environment.BUST_LEGACY_JAVASCRIPT_CACHE_ON_RELOAD
    ? Date.now().toString()
    : environment.BUILD_IDENTIFIER;

  return `/app.js?v=${buildIdentifier}`;
};
